var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "skype@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.202305%",
    y1: "4.21444588%",
    x2: "57.797695%",
    y2: "95.7855592%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7F0",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DE5",
    offset: "33.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082D9",
    offset: "75.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.202305%",
    y1: "4.21444588%",
    x2: "57.797695%",
    y2: "95.7855592%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "33.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "75.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.72221204%",
    y1: "72.7820405%",
    x2: "93.2720846%",
    y2: "27.2179595%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AD5",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082D9",
    offset: "57.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090DF",
    offset: "73.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3E7",
    offset: "87.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BCF2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.72221204%",
    y1: "72.7820405%",
    x2: "93.2720846%",
    y2: "27.2179595%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "57.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "73.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "87.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.4872758%",
    y1: "16.9344316%",
    x2: "80.3719454%",
    y2: "101.478038%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CC1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.4872758%",
    y1: "16.9344316%",
    x2: "80.3719454%",
    y2: "101.478038%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skype_logo_(2019\\u2013present)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07202691,0 C8.20291556,0 9.27180663,0.262139144 10.2197939,0.728244425 C5.40797179,1.47096032 1.57401669,5.10852784 0.617057918,9.83979412 C0.220321393,8.96812642 0,8.00147217 0,6.98399963 C0,3.12684314 3.1662543,0 7.07202691,0 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,17.0136002 C24,18.8665086 23.2546584,20.6435267 21.9279418,21.9537309 C20.6012252,23.263935 18.8018113,24 16.9255507,24 C15.8599037,24 14.8492884,23.7673138 13.9429591,23.3505826 C18.7106705,22.5467767 22.4778868,18.9000911 23.399096,14.1954112 C23.7917767,15.0760877 24,16.0342434 24,17.0136002 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0012116,0.990400696 C14.9719219,0.990400696 17.8209596,2.15581589 19.921569,4.23026824 C22.0221784,6.3047206 23.2022885,9.11828177 23.2022885,12.0520004 C23.2022885,14.9857191 22.0221784,17.7992803 19.921569,19.8737326 C17.8209596,21.948185 14.9719219,23.1136002 12.0012116,23.1136002 C9.0305013,23.1136002 6.18146357,21.948185 4.08085418,19.8737326 C1.98024479,17.7992803 0.800134724,14.9857191 0.800134724,12.0520004 C0.800134724,9.11828177 1.98024479,6.3047206 4.08085418,4.23026824 C6.18146357,2.15581589 9.0305013,0.990400696 12.0012116,0.990400696 Z M12.1530028,5.4264 C11.3611036,5.42175571 10.5743743,5.55302864 9.82768732,5.8144 C9.14114787,6.04405299 8.52826417,6.44981681 8.0514047,6.9904 C7.59255376,7.52871361 7.3499546,8.21566302 7.36995809,8.92 C7.35367227,9.47499841 7.48392283,10.024592 7.74782185,10.5144 C8.02116658,10.9780138 8.39888912,11.3728076 8.85153928,11.668 C9.45126757,12.0568137 10.088799,12.3851196 10.7545839,12.648 C11.4990078,12.9562667 12.0765688,13.2176 12.4872669,13.432 C12.8345427,13.6012358 13.1497462,13.8285701 13.4190078,14.104 C13.6227596,14.3182364 13.7360098,14.6016292 13.7355091,14.896 C13.753296,15.3171728 13.5651321,15.7210247 13.2300759,15.9808 C12.788917,16.2749259 12.2611138,16.4143269 11.7307319,16.3768 C11.430818,16.3798699 11.131518,16.3492749 10.8385536,16.2856 C10.600964,16.2339089 10.3685666,16.1610803 10.1441886,16.068 C9.94772096,15.9837333 9.67939463,15.8573333 9.3392096,15.6888 C9.06562916,15.5442135 8.76110419,15.4665857 8.45106829,15.4624 C8.17281083,15.4511316 7.90081876,15.5462151 7.69130376,15.728 C7.4890494,15.9187465 7.38133909,16.1877468 7.39660233,16.464 C7.39034685,16.7227981 7.46912003,16.9766045 7.62105986,17.1872 C7.8040656,17.4170082 8.04069611,17.599306 8.31058048,17.7184 C9.36625734,18.1717403 10.5106307,18.3862735 11.660488,18.3464 C12.49725,18.3630729 13.330081,18.2286124 14.1182173,17.9496 C14.7721529,17.7195389 15.3415976,17.3007588 15.7532047,16.7472 C16.1574152,16.1625334 16.3622516,15.4650731 16.3377631,14.7568 C16.3534552,14.1783391 16.2073065,13.6068557 15.9154923,13.1056 C15.6191311,12.6286812 15.2198695,12.2226978 14.7463754,11.9168 C14.1468529,11.5335839 13.510798,11.2096292 12.8473678,10.9496 C12.7764497,10.9151717 12.7030423,10.8860244 12.6277547,10.8624 C11.9479229,10.584 11.4365688,10.3605333 11.0936924,10.192 C10.787579,10.0498147 10.510365,9.8532324 10.275795,9.612 C10.0783907,9.40665241 9.9694958,9.13318011 9.97221213,8.8496 C9.95295261,8.40967444 10.1769713,7.9942561 10.5567706,7.7656 C10.9986582,7.50456247 11.5072816,7.37565515 12.0213964,7.3944 C12.4158519,7.39030744 12.8090744,7.43874062 13.1905133,7.5384 C13.6048972,7.65680125 14.0103983,7.803828 14.4040373,7.9784 C14.5637422,8.05182975 14.7374514,8.09056288 14.9135074,8.092 C15.1723109,8.0988016 15.4217255,7.99575871 15.598991,7.8088 C15.7860467,7.60621794 15.8842135,7.33830226 15.8718927,7.064 C15.8760426,6.8025636 15.783903,6.5485874 15.6127169,6.3496 C15.3803824,6.10774635 15.0922171,5.92545039 14.7730196,5.8184 C14.4254054,5.69191562 14.065958,5.59999667 13.6999834,5.544 C13.1886833,5.46089712 12.6711131,5.42155192 12.1530028,5.4264 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/skype.2641add8b36d8e3f01c454eaed6d5eff.svg";
export { ForwardRef as ReactComponent };